import { history } from '@umijs/max';
// import { stringify } from 'querystring';
import getSearchObject from './getSearchObject';
import Cookies from 'js-cookie';
import { Country, isGlobalEnv } from '../config';

/**
 * 重定向到登录页[携带redirect]
 */
export const redirectToLogin = () => {
    const { pathname } = history.location;
    const { redirect } = getSearchObject();

    Cookies.remove('service_center_user_rbac_token');
    Cookies.remove('service_center_user_rbac_token', {
        domain: '.popmart.com',
        Secure: true,
        SameSite: 'None',
        Partitioned: true,
    });

    if (pathname !== '/login' && !redirect) {
        // 跳转地址
        const search =
            pathname === '/' ? '' : `redirect=${window.location.href}`;

        if (!isGlobalEnv) {
            window.location.href = `${window.location.origin}#/login?${search}`; // 刷新浏览器
        } else {
            window.location.href = `${window.location.origin}/${Country}#/login?${search}`; // 刷新浏览器
        }
    }
};
